import { EditableImage } from "./EditableImage";
import type { Canvas as FabricCanvas } from "fabric/fabric-impl";

interface ImageEditProps {
  slug: string;
  screenshotUrl: string;
  fabricJson?: any;
  onSave?: (canvas: FabricCanvas) => Promise<void>;
  onCancel?: () => void;
  onReset?: () => Promise<void>;
  className?: string;
  isEditMode?: boolean;
}

export const ImageEdit = ({ 
  slug, 
  screenshotUrl, 
  fabricJson,
  onSave,
  onCancel,
  onReset,
  className,
  isEditMode = true
}: ImageEditProps) => {
  return (
    <EditableImage
      slug={slug}
      screenshotUrl={screenshotUrl}
      fabricJson={fabricJson}
      onSave={onSave}
      onCancel={onCancel}
      onReset={onReset}
      className={className}
      isEditMode={isEditMode}
    />
  );
};